/**
 * Salida estructurada del asistente de red (alineada con server/src/routes/ai-assistant.ts).
 */

export interface AiCableSuggestion {
  from: string
  to: string
  fibers?: number
  notes?: string
  tipo?: string
}

export interface NetworkAssistantStructured {
  summary?: string
  steps?: string[]
  cablesSuggested?: AiCableSuggestion[]
  warnings?: string[]
  editableNote?: string
  [key: string]: unknown
}

export function extractCablesSuggested(structured: unknown): AiCableSuggestion[] {
  if (!structured || typeof structured !== 'object') return []
  const cs = (structured as Record<string, unknown>).cablesSuggested
  if (!Array.isArray(cs)) return []
  const out: AiCableSuggestion[] = []
  for (const item of cs) {
    if (!item || typeof item !== 'object') continue
    const o = item as Record<string, unknown>
    const from = typeof o.from === 'string' ? o.from.trim() : ''
    const to = typeof o.to === 'string' ? o.to.trim() : ''
    if (!from || !to) continue
    let fibers: number | undefined
    if (typeof o.fibers === 'number' && Number.isFinite(o.fibers)) fibers = o.fibers
    else if (typeof o.fibers === 'string') {
      const n = parseInt(o.fibers, 10)
      if (Number.isFinite(n)) fibers = n
    }
    const notes = typeof o.notes === 'string' ? o.notes : undefined
    const tipo = typeof o.tipo === 'string' ? o.tipo : undefined
    out.push({ from, to, fibers, notes, tipo })
  }
  return out
}
